import type { Moment } from 'moment';

const checkIsTimeRangeOverlap = (arg: {
  timeRange: Moment[];
  timeRanges: Moment[][];
  index: number;
}) => {
  const {
    timeRange: [start, end],
    timeRanges,
    index,
  } = arg;

  const isOverlap = timeRanges.some((compareRange, timeRangeIndex) => {
    if (!compareRange || timeRangeIndex === index) {
      return false;
    }
    const [compareRangeStart, compareRangeEnd] = compareRange;
    const isStartBetween = start.isBetween(compareRangeStart, compareRangeEnd);
    if (isStartBetween) {
      return true;
    }
    const isEndBetween = end.isBetween(compareRangeStart, compareRangeEnd);
    if (isEndBetween) {
      return true;
    }
    return false;
  });

  return isOverlap;
};

export const timeRangeValidator = (arg: {
  timeRange: Moment[];
  timeRanges: Moment[][];
  index: number;
}) => {
  if (!arg.timeRange) {
    return Promise.reject(new Error('請選擇時間段'));
  }
  const [start, end] = arg.timeRange;
  const isStartAndEndSame = start.isSame(end, 'minute');
  if (isStartAndEndSame) {
    return Promise.reject(new Error('開始與結束時間不能相同'));
  }

  const isOverlap = checkIsTimeRangeOverlap(arg);

  if (isOverlap) {
    return Promise.reject(new Error('時間段重疊'));
  }
  return Promise.resolve();
};
